import {MODAL_TYPE} from '../actions/types';

const INITIAL_STATE = {
  modal: false,
  image: '',
  text: '',
  Notification: false,
  btntext: '',
  func: false,
  cancletext: 'منصرف شدم',
  number: '',
  pause_coefficient: 0,
  paydone: false,
  width: 0,
  height: 0,
  button_space_reverse: false,
  button_color_reverse: false,
};

const Modal = (state = INITIAL_STATE, action) => {
  switch (action.type) {
    case MODAL_TYPE:
      return {
        ...state,
        modal: action.payload.modal,
        image: action.payload.image,
        text: action.payload.text,
        Notification: action.payload.Notification,
        btntext: action.payload.btntext,
        func: action.payload.func,
        cancletext: action.payload.cancletext,
        number: action.payload.number,
        pause_coefficient: action.payload.pause_coefficient,
        paydone: action.payload.paydone,
        width: action.payload.width,
        height: action.payload.height,
        button_space_reverse: action.payload.button_space_reverse,
        button_color_reverse: action.payload.button_color_reverse,
      };
    default:
      return state;
  }
};

export default Modal;
